import Link from 'next/link'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faStar as faStarSolid } from '@fortawesome/free-solid-svg-icons'
import {faStar} from '@fortawesome/free-regular-svg-icons'

import {GET, UPOST} from '../helpers'
import {TOKEN, SUBMIT_FEEDBACK_URL} from '../vars'

const RatingInput = props => (
  [1,2,3,4,5].map((rating)=>{
    if(props.rating_val >= rating) {
      return  <span key={rating}><FontAwesomeIcon icon={faStarSolid} size="2x " className="text-warning mr-2" onClick={(e)=>{props.handleRating(rating,props.name)}}/></span>
    }
    else {
      return <span key={rating}><FontAwesomeIcon icon={faStar} size="2x" className="mr-2" onClick={(e)=>{props.handleRating(rating,props.name)}}/></span>
    }
  })
)

export default class Feedback extends React.Component  {
  constructor(props){
    super(props)
    this.state = {
      errors:{},
      form: {},
      redirect:this.props.redirect
    }
  }
  handleChange = (e) => {
    let form = this.state.form
    form[e.target.name] = e.target.value
    this.setState({form:form, submit_success:undefined, form_submit_error:undefined})
    if(this.props.user) {
      form['email'] = this.props.user.email
      this.setState({form:form})
    }
  }

  handleRating = (rating, name)=>{
      let form = this.state.form
      form[name] = rating
      this.setState({form:form, submit_success:undefined, form_submit_error:undefined})
  }

  handleFormSubmit = (e) => {

    e.preventDefault()
    let redirect_page = this.state.redirect?this.state.redirect:"/"
    this.setState({form_processing:true, form_submit_error:undefined})

    UPOST(SUBMIT_FEEDBACK_URL, this.state.form).then((response)=>{
      this.setState({submit_success:true, form_processing:false})
      setTimeout(function(){
        window.location.href=redirect_page
      }, 2000)

    }).catch((error)=>{

      this.setState({
        submit_success:false,
        form_processing:false,
        form_submit_error: error.response ? error.response.data.msg : 'Error submitting form'
      })

      if(error.response && error.response.data && error.response.data.errors) {
        let errorData = error.response.data.errors
        let errors = {}
        Object.keys(errorData).forEach((field)=>{
            errors[field] = errorData[field]
            this.setState({errors:errors})
        })
      }

    })
  }
  render() {
    let user = this.props.user
    // email field
    let email_field = <input type="email" name="email" className="form-control" onChange={this.handleChange} value={this.state.form.email} required/>
    if (user && user.email) {
      email_field = <input type="email" name="email" className="form-control" value={user.email} disabled/>
    }

    // submit button
    let submitBtn = <button type="submit" className="btn btn-block btn-primary">Submit</button>
    if(this.state.form_processing) {
      submitBtn = <button type="submit" className="btn btn-block btn-primary" disabled>Submitting..</button>
    }
    else if(this.state.submit_success) {
      submitBtn = <button type="submit" className="btn btn-block btn-primary" disabled>Done <FontAwesomeIcon icon={faCheck} className="ml-1" /></button>
    }

    // form errors
    let form_error
    if(this.state.form_submit_error) {
      form_error = <small className="text-danger">{this.state.form_submit_error}</small>
    }

    // payment gateway experience
    let payment_rating
    if (this.state.redirect) {
      payment_rating = <div className="mb-3">
        <label>Your Payment gateway experience</label>
        <div className="d-flex justify-content-between">
           <RatingInput name="payment_rating" rating_val={this.state.form.payment_rating} handleRating={this.handleRating}/>
         </div>
      </div>

    }

    let form = <>
      <form onSubmit={this.handleFormSubmit}>
        <div className="mb-3">
          <label className='form-label'>Your search experience</label>
          <div className="d-flex justify-content-between">
             <RatingInput name="search_rating" rating_val={this.state.form.search_rating} handleRating={this.handleRating}/>
           </div>
        </div>
        <div className="mb-3">
          <label className='form-label'>Your overall experience</label>
          <div className="d-flex justify-content-between">
             <RatingInput name="overall_rating" rating_val={this.state.form.overall_rating} handleRating={this.handleRating}/>
           </div>
        </div>

        <div className="mb-3">
          <label className='form-label' htmlFor="contact_number">Email address</label>
          {email_field}
        </div>
        <div className="mb-3">
          <label className='form-label'>Suggestions/Comments</label>
          <textarea name="message" value={this.state.form.message} className="form-control" onChange={this.handleChange} required>
          </textarea>
        </div>

        <div className="mb-3 text-center mt-2">
          {form_error}
          {submitBtn}

        </div>

      </form>
      <div className="text-center">
      <Link href={this.state.redirect?this.state.redirect:"/"}>
        <a className="mt-4 ">Skip</a>
      </Link>
      </div>
    </>
    if(this.state.submit_success) {
      let redirect_text = "Please hold while we redirect."
      if (this.state.redirect){
          redirect_text = "Please hold while we redirect to your orders"
      }
      form = <>
        <p className="text-center">
          <FontAwesomeIcon icon={faCheck} className="mr-1 text-success" /> Thanks for the feedback, Message has been sent to support team.
        </p>
        <div className="text-center">
          <small>Please hold while we redirect to your orders</small>
        </div>
      </>
    }
    return <div>
          <h3 className="text-center mb-3">
            <small>Feedback</small>
          </h3>
          {form}
        </div>
  }

}
